import React from 'react';
import { LocalMessageFormatter, MessageFormatter } from '../util/LocalMessageFormatter';
import { useIntl } from 'react-intl';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const MessageContext = React.createContext<MessageFormatter>(null!);

const MessageProvider = ({ children }: { children: React.ReactNode }) => {
  const messageFormatter = new LocalMessageFormatter(useIntl());
  return <MessageContext.Provider value={messageFormatter}>{children}</MessageContext.Provider>;
};

export { MessageProvider, MessageContext };
